import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import { useTranslation } from "react-i18next";
import React from "react";

const Bullet = ({ text, index }: { text: string; index: number }) => (
  <ListItem alignItems="flex-start" sx={{ padding: "0px 10px" }}>
    <ListItemIcon sx={{ marginTop: "12px", minWidth: "15px" }}>
      <CircleIcon sx={{ height: "5px", width: "5px" }} />
    </ListItemIcon>
    <ListItemText
      sx={{ lineHeight: "1.3" }}
      primary={<Typography variant="secondary">{text}</Typography>}
    />
  </ListItem>
);

const BulletDescription = () => {
  const { t } = useTranslation();

  const bullets = [
    t("accountSettings:gdpr:personalInfo:bullet_one"),
    t("accountSettings:gdpr:personalInfo:bullet_two"),
    t("accountSettings:gdpr:personalInfo:bullet_three"),
    t("accountSettings:gdpr:personalInfo:bullet_four"),
  ];

  const bulletListItems = bullets.map((text, index) => (
    <Bullet
      key={"forbidPersonalInfoUpdates-bullet-" + index}
      text={text}
      index={index}
    />
  ));

  return (
    <List disablePadding sx={{ paddingLeft: "15px", paddingRight: "20px" }}>
      <Box alignItems="flex-start" sx={{ padding: "0px 16px 18px 14px" }}>
        <Typography variant="secondary">
          {t("accountSettings:gdpr:personalInfo:description")}
        </Typography>
        {<List sx={{ paddingTop: "4px" }}>{bulletListItems}</List>}
      </Box>
    </List>
  );
};

export default BulletDescription;
